import { utils } from "@intrasync/utils";
import { ButtonGroup } from "@mui/material";

import React from "react";

import Button from "./Button";
// import { ButtonPropTypes } from './buttonPropsTypes';
import injectStores from "../RootStore/injectStores";
interface ButtonGroupProps {
  buttons?: Array<{
    onClick: () => void;
    children?: React.ReactNode;
    // Add other properties from buttonPropTypes here
  }>;
  children?: React.ReactNode;
}

const ButtonGroupBase = injectStores(
  ({ buttons, children }: ButtonGroupProps) => {
    if (buttons && buttons.length) {
      return (
        <ButtonGroup>
          {buttons.map((buttonProps) => {
            const { children: buttonChildren, ...rest } = buttonProps;
            return (
              <Button key={utils.uuid()} {...rest}>
                {buttonChildren}
              </Button>
            );
          })}
        </ButtonGroup>
      );
    }
    return <ButtonGroup>{children}</ButtonGroup>;
  }
);

export default ButtonGroupBase;
